// @flow
import { defineMessages } from 'react-intl';

/*eslint max-len:0*/
/* eslint-disable max-len */
// ChangePassword Error messages.
export const resetPassword = defineMessages({
    DEFAULT_ERROR_MSG: {
        id: 'auth.reset-password.default',
        defaultMessage: 'Oops! An unexpected error has occurred. Please refresh to continue or try again later.'
    },
    REQUIRED: {
        id: 'auth.reset-password.required',
        defaultMessage: 'Required'
    },
    OLD_PASSWORD_INVALID_MSG: {
        id: 'auth.reset-password.wrong-old-password',
        defaultMessage: 'Oops! That does not look like your old password. Please try again.'
    },
    MISMATCH: {
        id: 'auth.reset-password.passwords-do-not-match',
        defaultMessage: 'Oops! Your new passwords do not match. Please check and try again.'
    },
    MALFORMED: {
        id: 'auth.reset-password.password-validation',
        defaultMessage: 'Oops! Your password must be 8 characters or more with at least one number.'
    },
    NOT_NEW: {
        id: 'auth.reset-password.new-same-as-old',
        defaultMessage: 'Your new password must not be the same as your old password.'
    },
    TOO_MANY_REQUESTS: {
        id: 'auth.reset-password.too-many-requests',
        defaultMessage:
            'There have been too many attempts to reset this password. Please wait a few minutes and try again.'
    },
    CODE_INVALID: {
        id: 'auth.code.invalid',
        defaultMessage: 'The verification code must be exactly 6 digits'
    },
    NOT_AUTHORIZED: {
        id: 'auth.code.not-authorized',
        defaultMessage: 'The verification code you sent has expired.'
    }
});

/* eslint-enable max-len */
// Validation Errors
export const REQUIRED = 'Required';
export const MAX_LENGTH = 'MaxLength';
export const ALPHA_ONLY = 'AlphaOnly';
export const INVALID_MOBILE_NUMBER = 'InvalidMobileNumber';
export const NOT_UNIQUE = 'NotUnique';

export const VALIDATION_MESSAGE = {
    Required: 'Oops! This field is required.',
    AlphaOnly: 'Oops! Use only letters when entering a contact name...',
    InvalidMobileNumber: 'Please enter a valid (UK) 11 digit mobile number.',
    NotUnique: 'Mobile number already used.'
};

export const generalErrorMessages = defineMessages({
    tryAgain: {
        id: 'general.try-again',
        defaultMessage: 'Oops, An unexpected error occurred. Please try again or refresh the page'
    }
});



// WEBPACK FOOTER //
// ./src/core/constants/errors.js